import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import './Help.css';

class Help extends Component {
  	render() {
  		const content = this.props.help.content;
		return (
	  		<div className="showtix-box">
	  			<div className="showtix-padder">
					<h3 className="showtix-box__title">{this.props.help.title}</h3>
					{ReactHtmlParser(content)}
				</div>	
		  	</div>
		);
  	}
}

Help.propTypes = {
    help: PropTypes.shape({
        content: PropTypes.string,
        title: PropTypes.string
    })
}

export default Help;



// WEBPACK FOOTER //
// ./src/components/Common/Help/Help.js